import { useIntl } from "react-intl";
import AsyncSelect from "@ticketingplatform/ui/dist/components/atoms/Fields/Select/AsyncSelect";

import { useVenueSelect } from "./hooks";
import { VenueSelectProps } from "./types";

const VenueSelect: React.FC<VenueSelectProps> = ({
  value,
  onChange,
  ...props
}) => {
  const intl = useIntl();
  const venueSelect = useVenueSelect({ value, onChange });

  return (
    <AsyncSelect
      {...venueSelect}
      placeholder={intl.formatMessage({ defaultMessage: "Choose venue" })}
      {...props}
    />
  );
};

export default VenueSelect;
